import { render, staticRenderFns } from "./qualitysafe.vue?vue&type=template&id=4e89ed3f&scoped=true"
import script from "./qualitysafe.vue?vue&type=script&lang=js"
export * from "./qualitysafe.vue?vue&type=script&lang=js"
import style0 from "./qualitysafe.vue?vue&type=style&index=0&id=4e89ed3f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e89ed3f",
  null
  
)

export default component.exports